import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { TextWrapper, Wrapper } from "../../../constants/common/StyledGlobalConstants";
import ContactOverview from "./ContactOverview";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";

const { TABLET } = DEVICE_BREAKPOINTS;

function ContactDetailsModal(props) {
  const { windowSize } = useSelector((state) => state.ACCOUNT);

  return (
      <Wrapper display="flex" flexDirection="column" alignItems="flex-start" width="100%">
        <TextWrapper fontFamily="neue-haas-grotesk-display" fontSize="2.5rem" fontWeight="700" lineHeight="3rem">
          Enter contact details
        </TextWrapper>
        <TextWrapper fontSize="0.875rem" fontWeight="400" marginTop="1.5rem !important" lineHeight="1.25rem">
          Enter contact details and the location where the appointment will take place.
        </TextWrapper>
        <div
          style={{
            border: "1px solid #D8DADA",
            borderRadius: "5px",
            marginTop: `${windowSize.width < TABLET ? "24px" : "32px"}`,
            padding: "0px 24px 24px",
            width: "100%",
            marginBottom: "82px",
          }}
        >
          <ContactOverview setIsNextDisabled={props.setIsNextDisabled} />
        </div>
      </Wrapper>
  );
}

ContactDetailsModal.propTypes = {
  setIsNextDisabled: PropTypes.func.isRequired,
};

export default ContactDetailsModal;
